// modules/permissions/index.ts
function hasPermission(granted, required) {
  if (granted.has("*")) return true;
  if (granted.has(required)) return true;
  const parts = required.split(".");
  if (granted.has(parts[0] + ".*")) return true;
  const action = parts.slice(1).join(".");
  if (action && granted.has("*." + action)) return true;
  return false;
}
export {
  hasPermission
};
